import { useTranslation } from 'react-i18next'
import { Button } from 'src/components/button'

interface SelectAllBannerProps {
  /** Server total matching the active filters (`res.count`), not the page size. */
  totalCount: number
  onSelectAll: () => void
}

/**
 * Shown when the whole current page is explicitly selected but more rows match
 * the active filters than fit on one page. Offers to extend the selection to
 * every matching row across all pages. The count is always the server total.
 */
export const SelectAllBanner = ({ totalCount, onSelectAll }: SelectAllBannerProps) => {
  const { t } = useTranslation()
  return (
    <div
      className="m-2 flex items-center justify-center gap-2 rounded-lg bg-primary-50 px-4 py-2 text-sm text-primary-800"
      data-testid="select-all-banner"
    >
      <span>{t('bulkActions.pageSelected', { count: totalCount })}</span>
      <Button
        variant="text"
        tone="primary"
        size="sm"
        onClick={onSelectAll}
        data-testid="select-all-matching"
      >
        {t('bulkActions.selectAllMatching', { count: totalCount })}
      </Button>
    </div>
  )
}
